"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackRect = void 0;
const React = require("react");
const useTrackRect = ({ target, onChange, enabled = true }) => {
    const lastRectRef = React.useRef(null);
    const callbackRef = React.useRef(onChange);
    const rafIdRef = React.useRef(null);
    React.useEffect(() => {
        callbackRef.current = onChange;
    }, [onChange]);
    React.useEffect(() => {
        if (!enabled)
            return;
        const el = target;
        if (!el)
            return;
        const track = () => {
            const rect = el.getBoundingClientRect();
            const last = lastRectRef.current;
            if (!last ||
                rect.top !== last.top ||
                rect.left !== last.left ||
                rect.width !== last.width ||
                rect.height !== last.height) {
                callbackRef.current(rect);
                lastRectRef.current = rect;
            }
            rafIdRef.current = requestAnimationFrame(track);
        };
        rafIdRef.current = requestAnimationFrame(track);
        return () => {
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
            }
        };
    }, [target, enabled]);
};
exports.useTrackRect = useTrackRect;
